export default __webpack_public_path__ + "static/media/kitchen4-afterD-1920w.8ae68dc2.webp";